export enum LayerType {
  SATELLITE = 'SATELLITE',
  PLAN = 'PLAN',
  CADASTRE = 'CADASTRE'
}
